module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-upload",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "dropbox",
    class: [{
      'is-dragging': _vm.dragging,
      'is-dirty': _vm.vuelidate.models[_vm.uploadFieldName].$dirty,
      'is-invalid': _vm.vuelidate.models[_vm.uploadFieldName].$invalid
    }]
  }, [(_vm.rerender) ? _c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "multiple": "",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
      },
      "dragenter": function($event) {
        _vm.dragging = true
      },
      "dragend": function($event) {
        _vm.dragging = false
      },
      "dragleave": function($event) {
        _vm.dragging = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.isInitial) ? _c('p', {
    staticClass: "description"
  }, [_vm._v("\n          Drag your file(s) here to begin"), _c('br'), _vm._v(" or click to browse " + _vm._s(_vm.vuelidate.models[_vm.uploadFieldName].$params.required ? '*' : '(optional)') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isInitial) ? _c('p', {
    staticClass: "description ie-only"
  }, [_vm._v("\n          Click to browse " + _vm._s(_vm.vuelidate.models[_vm.uploadFieldName].$params.required ? '*' : '(optional)') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n          Previewing " + _vm._s(_vm.fileCount) + " files...\n        ")]) : _vm._e()])])]), _vm._v(" "), (_vm.uploadedFiles && _vm.uploadedFiles.length > 0) ? _c('div', {
    staticClass: "dropbox-overlay"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline"
  }, _vm._l((_vm.uploadedFiles), function(fileInfo) {
    return _c('div', {
      staticClass: "column is-4"
    }, [(fileInfo.preview) ? _c('img', {
      staticStyle: {
        "max-width": "100%",
        "max-height": "140px",
        "margin": "auto"
      },
      attrs: {
        "src": fileInfo.preview
      }
    }) : _vm._e(), _vm._v(" "), (fileInfo.file) ? _c('p', {
      staticStyle: {
        "position": "absolute",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v("\n          " + _vm._s(fileInfo.file.name) + "\n        ")]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isFailed) ? _c('div', {
    staticClass: "dropbox-overlay"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("\n        Error: " + _vm._s(_vm.uploadError) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isSuccess || _vm.isFailed) ? _c('div', {
    staticClass: "dropbox-reset",
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "right": "15px"
    }
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isSuccess && false) ? _c('div', [_c('p', [_vm._v("Uploaded " + _vm._s(_vm.uploadedFiles.length) + " file(s) successfully.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "button is-danger",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("\n        reset\n      ")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.uploadedFiles), function(item) {
    return _c('li', [_c('img', {
      staticClass: "img-responsive img-thumbnail",
      attrs: {
        "src": item.url,
        "alt": item.originalName
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isFailed && false) ? _c('div', [_c('p', [_vm._v("Uploaded failed.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "button is-danger",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("\n        reset\n      ")])]), _vm._v(" "), (_vm.uploadError) ? _c('pre', [_vm._v("Upload failed: " + _vm._s(_vm.uploadError))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddf21b4e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormUpload.vue
// module id = 840
// module chunks = 1